import React from "react";
import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet";

interface SheetProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  hasHeader?: boolean;
}

export default function CustomSheet({ onClose, open, children }: SheetProps) {
  return (
    <Sheet
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <SheetContent
        className="md:w-[504px] w-full p-0 overflow-y-auto"
        onInteractOutside={(event) => {
          // Toast fica fora do Sheet: clicar nele não pode fechar o painel.
          const target = event.detail.originalEvent.target;
          if (target instanceof Element && target.closest('[role="status"]')) {
            event.preventDefault();
          }
        }}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
}